<template>
  <div class="panel">
    <el-row>
      <h1>Welcome to contribute to Tigo!</h1>
      <div class="content">Tigo is an open source framework, welcome to contribute to Tigo. Please glance README before commit code.</div>
      <div class="content">You should fork the project firstly, then make a PULL request, we will merge your codes if accepted.</div>
    </el-row>
    <el-row>
      <img src="../../assets/contribute.png" class="contribute"/>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: "DocumentationContribute"
  }
</script>

<style scoped>
  .panel {
    height: 450px;
    width: 100%;
    background-color: #ffffff;
  }

  h1 {
    margin-top: 30px;
  }

  .content {
    color: #797e8e;
    font-family: "Avenir", serif;
  }

  .contribute {

  }

  @media screen and (max-width: 1005px) {
    .contribute{
      display: none;
    }
    .panel {
      height: auto;
      width: 100%;
      background-color: #ffffff;
      padding-bottom: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/en/DocumentationContribute.vue